import InstanceOverview from 'src/interfaces/instanceInterfaces';
import React, { useEffect, useState } from 'react';
import { ButtonDropdown } from '@amzn/awsui-components-console';
import InstanceBulkActionConfirmModal from './InstanceBulkActionConfirmModal';
import { Operation } from 'src/constants/hammerstoneConstants';
import keys from 'src/constants/hammerstoneConstantKeys';

const dropdownItems = [
	// TODO running into some problems with rerun operations however, since it's not required for feature parity
	// it will be introduced in a upcoming fix
	// {
	//     id: keys.Operation.rerun,
	//     text: Operation.rerun,
	//     iconSvg: CustomSVG.Rerun,
	// },
	{
		id: keys.Operation.upload_confidence_file,
		text: Operation.upload_confidence_file,
		iconName: 'upload',
	},
] as const;

export default function InstanceBulkActionDropdown(props: {
	selectedInstances: InstanceOverview[];
	setSelectedInstances: (instances: InstanceOverview[]) => void;
	isRefreshing: boolean;
}) {
	const [action, setAction] = useState<string>(''); // bulk action selected
	const handleItemClick = ({ detail }: { detail: { id: string } }) => {
		setAction(detail.id);
	};

	// Clear selected instances when action is cleared
	useEffect(() => {
		if (!action) {
			props.setSelectedInstances([]);
		}
	}, [action, props.setSelectedInstances]);

	return (
		<>
			<ButtonDropdown
				data-testid="bulkEditActivitiesActions"
				items={dropdownItems}
				disabled={!props.selectedInstances?.length || props.isRefreshing}
				onItemClick={handleItemClick}
			>
				Bulk actions
			</ButtonDropdown>
			<InstanceBulkActionConfirmModal
				action={action}
				setAction={setAction}
				selectedInstances={props.selectedInstances}
			/>
		</>
	);
}
